import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";

export class ReportCreatedNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		return {
			openReportDownload: true
		};
	}

	public getIcon():string {
		return "file";
	}

	public getTone():string {
		return "info";
	}

	public getActionKey():string {
		return "download";
	}
}
